(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pk-breadcrumbs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.__pkBreadcrumbCollectionTracker) {
  window.__pkBreadcrumbCollectionTracker = true;

  document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link) return;

  try {
    const targetUrl = new URL(link.href, window.location.origin);
    if (targetUrl.origin !== window.location.origin) return;

    /* 点击 Collection 链接时，先记住这个 Collection */
    const collectionMatch = targetUrl.pathname.match(
      /\/collections\/([^/?#]+)(?:\/)?$/
    );

    if (collectionMatch) {
      const collectionHandle = decodeURIComponent(collectionMatch[1]);

      if (collectionHandle && collectionHandle !== 'all') {
        sessionStorage.setItem(
          'pkBreadcrumbSource',
          JSON.stringify({
            handle: collectionHandle,
            product: '',
            time: Date.now()
          })
        );
      }

      return;
    }

    /* 点击产品时，识别产品 handle */
    const productMatch = targetUrl.pathname.match(
      /\/products\/([^/?#]+)/
    );

    if (!productMatch) return;

    const productHandle = decodeURIComponent(productMatch[1]);

    /* 优先看产品链接自己是否带 Collection */
    const nestedCollectionMatch = targetUrl.pathname.match(
      /\/collections\/([^/?#]+)\/products\//
    );

    let collectionHandle = nestedCollectionMatch
      ? decodeURIComponent(nestedCollectionMatch[1])
      : '';

    /* 再看当前页面是不是 Collection 页面 */
    if (!collectionHandle) {
      const currentCollectionMatch = window.location.pathname.match(
        /\/collections\/([^/?#]+)/
      );

      if (currentCollectionMatch) {
        collectionHandle = decodeURIComponent(currentCollectionMatch[1]);
      }
    }

    /* Mega Menu / 子菜单直接点产品：
       使用刚刚记住的 Collection */
    if (!collectionHandle) {
      const previousSource = JSON.parse(
        sessionStorage.getItem('pkBreadcrumbSource') || 'null'
      );

      if (
        previousSource &&
        previousSource.handle &&
        Date.now() - previousSource.time < 10 * 60 * 1000
      ) {
        collectionHandle = previousSource.handle;
      }
    }

    if (!collectionHandle) return;

    sessionStorage.setItem(
      'pkBreadcrumbSource',
      JSON.stringify({
        handle: collectionHandle,
        product: productHandle,
        time: Date.now()
      })
    );
  } catch (error) {}
}, true);
}
    if (customElements.get('pk-breadcrumbs-v1')) return;

    customElements.define('pk-breadcrumbs-v1', class extends HTMLElement {
      connectedCallback() {
        const dataNode = this.querySelector('[data-pk-bc-context]');
        if (!dataNode) return;

        try {
          const config = JSON.parse(dataNode.textContent);
          const choices = Array.isArray(config.collections) ? config.collections : [];
let selected = null;
if (config.allow_referrer) {
  try {
    const savedSource = JSON.parse(
      sessionStorage.getItem('pkBreadcrumbSource') || 'null'
    );

    const currentProductMatch = window.location.pathname.match(
      /\/products\/([^/?#]+)/
    );

    const currentProductHandle = currentProductMatch
      ? decodeURIComponent(currentProductMatch[1])
      : '';

    if (
  savedSource &&
  savedSource.handle &&
  savedSource.product &&
  savedSource.product === currentProductHandle &&
  Date.now() - savedSource.time < 30 * 60 * 1000 &&
  !['best-seller', 'sale', 'patio-furniture'].includes(savedSource.handle)
) {
  selected = choices.find(
    item => item.handle === savedSource.handle
  ) || null;
}
  } catch (error) {}
}

if (!selected && config.allow_referrer && document.referrer) {
  const source = new URL(document.referrer);

  if (source.origin === window.location.origin) {
    const sourcePath = this.cleanPath(source.pathname);
    const root = new URL(config.root_url || '/', window.location.origin);

    selected = choices.find(item => {
      const target = new URL(item.url, window.location.origin);
      if (target.origin !== window.location.origin) return false;

      const paths = [
        this.cleanPath(target.pathname),
        this.cleanPath(root.pathname + '/collections/' + item.handle)
      ];

      return paths.some(path => this.isCollectionPath(sourcePath, path));
    });
  }
}

if (!selected) {
  const fallbackExcluded = [
    'best-seller',
    'sale',
    'patio-furniture'
  ];

  const contextChoice = config.context_handle
    ? choices.find(item => item.handle === config.context_handle)
    : null;

  if (
    contextChoice &&
    !fallbackExcluded.includes(contextChoice.handle)
  ) {
    selected = contextChoice;
  }

  if (!selected) {
    selected = choices.find(
      item => !fallbackExcluded.includes(item.handle)
    ) || contextChoice || choices[0] || null;
  }
}

          const itemNode = this.querySelector('[data-pk-bc-collection]');
          const linkNode = this.querySelector('[data-pk-bc-collection-link]');
          const overviewNode = this.querySelector('[data-pk-bc-overview]');
          if (!itemNode || !linkNode) return;

          if (selected) {
            const target = new URL(selected.url, window.location.origin);
            if (target.origin !== window.location.origin) return;
            linkNode.href = target.href;
            linkNode.textContent = selected.title;
            itemNode.hidden = false;
            if (overviewNode) overviewNode.hidden = !config.show_overview;
          } else {
            itemNode.hidden = true;
            linkNode.removeAttribute('href');
            linkNode.textContent = '';
            if (overviewNode) overviewNode.hidden = true;
          }
        } catch (_error) {
          // Keep the server-rendered Home/product or verified-context breadcrumb.
        }
      }

      cleanPath(path) {
        return path.replace(/\/+/g, '/').replace(/\/$/, '') || '/';
      }

      isCollectionPath(sourcePath, collectionPath) {
        if (sourcePath === collectionPath) return true;
        if (!sourcePath.startsWith(collectionPath + '/')) return false;
        const suffix = sourcePath.slice(collectionPath.length + 1);
        // A single tag filter is a collection page; a nested product URL isn't.
        return Boolean(suffix) && suffix !== 'products' && !suffix.includes('/');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
